import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { Suspense, lazy } from 'react';
import ErrorPage from '../modules/error/ErrorPage';
import RolesRoutes from './RolesRoutes';
import CategoryRoutes from './CategoryRoutes';
import WorkflowRoutes from './WorkflowRoutes';
import LabourersRoutes from './LabourersRoutes';
import EmployeeRoutes from './EmployeeRoutes';

import WarehouseRoutes from './WarehouseRoutes';
import VehiclesRoutes from './VehiclesRoutes';
import LogisticsRoutes from './LogisticsRoutes';
import CompanyDetailsRoutes from './CompanyDetailsRoutes';

const Roles = lazy(() => import('../modules/admin/roles'));
const Units = lazy(() => import('../modules/admin/units'));
const Department = lazy(() => import('../modules/admin/department'));
const MasterTasks = lazy(() => import('../modules/admin/manageMasterTask'));
const ProjectTypes = lazy(() => import('../modules/admin/projectType'));
const ProjectTypeDetails = lazy(() => import('../modules/admin/projectType/ProjectTypeDetails'));

const AdminRoutes = (
  <>
    <Route
      path="/admin"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Roles />
        </Suspense>
      }
    >
      {RolesRoutes}
      {CategoryRoutes}
      {WorkflowRoutes}
      <Route
        path="units"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <Units />
          </Suspense>
        }
        errorElement={<ErrorPage />}
      />
      <Route
        path="department"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <Department />
          </Suspense>
        }
      />
      <Route
        path="project-types"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <ProjectTypes />
          </Suspense>
        }
      />
      <Route
        path="project-types/:id"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <ProjectTypeDetails />
          </Suspense>
        }
      />
      <Route
        path="manage-master-tasks"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <MasterTasks />
          </Suspense>
        }
      />
      {LabourersRoutes}
      {EmployeeRoutes}
      {/* {WarehouseRoutes} */}
      {VehiclesRoutes}
      {LogisticsRoutes}
      {CompanyDetailsRoutes}
    </Route>
  </>
);

export default AdminRoutes;
